// Requires jQuery
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import moment from "moment";

const PAGE_TYPES = ['channel', 'channels_index', 'monitoring', 'issue', 'tip_review', 'project_posts']
const ENGAGEMENT_FIELDS = ['engagement', 'views', 'likes', 'shares', 'comments', 'followers', 'posts_loaded', 'total_posts']
const ENGAGEMENT_STATISTICS_FIELDS = ['eng_per_post', 'eng_per_post_last_30', 'eng_per_post_last_7', 'total_posts_last_30', 'total_posts_last_90']
const RATIO_FIELDS = ['follower_to_following_ratio', 'eng_per_post_by_follower_ratio']
const ENGAGEMENT_SCORES_FIELDS = ["likes_score", "views_score", "shares_score", "comments_score"]



const ENGAGEMENT_RANGES = {
  'min': 0,
  '5%': 10,
  '10%': 100,
  '15%': 1000,
  '20%': 10000,
  '30%': 50000,
  '40%': 100000,
  '50%': 500000,
  '60%': 1000000,
  '65%': 5000000,
  '70%': 10000000,
  '80%': 50000000,
  '85%': 100000000,
  '90%': 500000000,
  'max': 1000000000
}

const RATIO_RANGES = {
  'min': 0.0,
  '10%': 0.1,
  '20%': 0.2,
  '30%': 0.3,
  '40%': 0.4,
  '50%': 0.5,
  '60%': 0.6,
  '70%': 0.7,
  '80%': 0.8,
  '90%': 0.9,
  'max': 1.0
}

const SCORE_RANGES = {
  'min': -100,
  '4%': -80,
  '8%': -60,
  '12%': -50,
  '16%': -40,
  '20%': -30,
  '24%': -20,
  '28%': -15,
  '32%': -10,
  '36%': -8,
  '40%': -6,
  '44%': -4,
  '48%': -2,
  '52%': 0,
  '56%': 2,
  '60%': 4,
  '64%': 6,
  '68%': 8,
  '72%': 10,
  '76%': 15,
  '80%': 20,
  '84%': 30,
  '88%': 50,
  '92%': 60,
  '96%': 80,
  'max': 100
}

const STATISTICS_RANGES = {
  'min': 0,
  '10%': 100,
  '20%': 500,
  '30%': 1000,
  '40%': 5000,
  '50%': 10000,
  '60%': 50000,
  '70%': 100000,
  '80%': 500000,
  '90%': 1000000,
  'max': 5000000
}

import { initializeEngagmentSlider } from "./helpers";

// Initialize slider:
$(document).on('turbolinks:load', function() {
  initializeEngagmentSlider("#eng-slider", true)
  initAgeSlider()
  initObservedAtSlider()
  initializeEngagementsSlider()
});

function initObservedAtSlider(){
  let url = new URL(window.location.href);

  var min_ob = $('#min-ob')
  var max_ob = $('#max-ob')
  var ob_slider = $('#ob-slider')[0];

  if(ob_slider){
    var min_ob_limit = $('#min_ob_limit').val();

    var min_ob_val = url.searchParams.get('observed_at_from')
    var max_ob_val = url.searchParams.get('observed_at_to')
  
    min_ob_val = (min_ob_val) ? new Date(parseInt(min_ob_val)) : new Date(parseInt(min_ob_limit) * 1000)
    max_ob_val = (max_ob_val) ? new Date(parseInt(max_ob_val)) : new Date()
  
    min_ob.text(moment(min_ob_val).format('MM/DD/YYYY'))
    max_ob.text(moment(max_ob_val).format('MM/DD/YYYY'))
  
    noUiSlider.create(ob_slider, {
      start: [min_ob_val.getTime(), max_ob_val.getTime()],
      connect: true,
      step: 24 * 60 * 60 * 1000,
      range: {
        'min': new Date(parseInt(min_ob_limit) * 1000).getTime(),
        'max': new Date().getTime()
      }
    });
  
    ob_slider.noUiSlider.on('update', function (values, handle) {
      updateValues(values, handle, min_ob, max_ob, ob_slider);
    });
  
    ob_slider.noUiSlider.on('change', function (values, handle) {
      reloadForObservedAt(values, handle, min_ob, max_ob, ob_slider);
    });
  
    ob_slider.noUiSlider.set([parseInt(min_ob_val), parseInt(max_ob_val)]);
  }
}

function initAgeSlider(){
  let url = new URL(window.location.href);

  var min_age = $('#min-age')
  var max_age = $('#max-age')
  var age_slider = $('#age-slider')[0];

  if (age_slider){
    var min_age_limit = $('#min_age_limit').val();

    var min_age_val = url.searchParams.get('published_at_from')
    var max_age_val = url.searchParams.get('published_at_to')

    min_age_val = (min_age_val) ? new Date(parseInt(min_age_val)) : new Date(parseInt(min_age_limit) * 1000)
    max_age_val = (max_age_val) ? new Date(parseInt(max_age_val)) : new Date()

    min_age.text(moment(min_age_val).format('MM/DD/YYYY'))
    max_age.text(moment(max_age_val).format('MM/DD/YYYY'))

    noUiSlider.create(age_slider, {
      start: [min_age_val.getTime(), max_age_val.getTime()],
      connect: true,
      step: 24 * 60 * 60 * 1000,
      range: {
        'min': new Date(parseInt(min_age_limit) * 1000).getTime(),
        'max': new Date().getTime()
      }
    });

    age_slider.noUiSlider.on('update', function (values, handle) {
      updateValues(values, handle, min_age, max_age, age_slider);
    });

    age_slider.noUiSlider.on('change', function (values, handle) {
      reloadForAge(values, handle, min_age, max_age, age_slider);
    });

    age_slider.noUiSlider.set([parseInt(min_age_val), parseInt(max_age_val)]);
  }

}

function initializeEngagementsSlider(){
  var slidersArray = ENGAGEMENT_FIELDS.concat(ENGAGEMENT_STATISTICS_FIELDS).concat(RATIO_FIELDS).concat(ENGAGEMENT_SCORES_FIELDS)
  PAGE_TYPES.map(function(page_type) { 
    slidersArray.map(function(type){
      let url = new URL(window.location.href);
      var min_value = $(`#${page_type}-min-${type}`)
      var max_value = $(`#${page_type}-max-${type}`)
      var slider = $(`#${page_type}-${type}-slider`)[0];
      if (slider) {
        var from_parameter_name = `${type}_from`
        var to_parameter_name = `${type}_to`
        if(page_type == "channels_index") {
          from_parameter_name = `post_filters[${type}_from]`
          to_parameter_name = `post_filters[${type}_to]`
        }  
        var min_search_val  = url.searchParams.get(from_parameter_name)
        var max_search_val = url.searchParams.get(to_parameter_name)

        var range = {}
        if (ENGAGEMENT_FIELDS.includes(type))
          range = ENGAGEMENT_RANGES
        else if (ENGAGEMENT_STATISTICS_FIELDS.includes(type))
          range = ENGAGEMENT_RANGES
        else if (RATIO_FIELDS.includes(type))
          range = RATIO_RANGES
        else if (ENGAGEMENT_SCORES_FIELDS.includes(type))
          range = SCORE_RANGES

        if (RATIO_FIELDS.includes(type)){
          min_value.text(min_search_val)
          max_value.text(max_search_val)
        } else {
          min_search_val = (min_search_val) ? parseInt(min_search_val) : range['min']
          max_search_val = (max_search_val) ? parseInt(max_search_val) : range['max']
      
          min_value.text(formatToHumanNumber(parseInt(min_search_val)))
          max_value.text(formatToHumanNumber(parseInt(max_search_val)))
        }

        console.log([range['min'], range['max']])

        noUiSlider.create(slider, {
          start: [range['min'], range['max']],
          snap: true,
          connect: true,
          range: range
        });
    
        // slider.noUiSlider.on('update', function (values, handle) {
        //   updateSliderValues(values, handle, min_value, max_value, slider, type);
        // });
    
        slider.noUiSlider.on('change', function (values, handle) {
          reloadSliderValues(slider, type, page_type, range);
        });


        if (RATIO_FIELDS.includes(type)){
          slider.noUiSlider.set([min_search_val, max_search_val]);
        } else {
          slider.noUiSlider.set([parseInt(min_search_val), parseInt(max_search_val)]);
        }
      }
    })

  })
  
}

function reloadSliderValues(slider, slider_type, page_type, range){
  setTimeout(function(){ 
    let url = new URL(window.location.href);

    var values = slider.noUiSlider.get()

    console.log(values)
    console.log(slider_type)

    var from_parameter_name = `${slider_type}_from`
    var to_parameter_name = `${slider_type}_to`
    if(page_type == "channels_index") {
      from_parameter_name = `post_filters[${slider_type}_from]`
      to_parameter_name = `post_filters[${slider_type}_to]`
    } 

    if (values[0] == range['min']) {
      url.searchParams.delete(from_parameter_name)
    } else {
      url.searchParams.set(from_parameter_name, values[0])
    }

    if (values[1] == range['max']) {
      url.searchParams.delete(to_parameter_name)
    } else {
      url.searchParams.set(to_parameter_name, values[1])
    }
  
    window.location.href = url.href;
  }, 1000);
}

function updateSliderValues(values, handle, min_value, max_value, view_slider) {
  var value = values[handle];
  if (handle == 0) {
    min_value.text(formatToHumanNumber(parseInt(value)));
  } else {
    max_value.text(formatToHumanNumber(parseInt(value)));
  }
}

function reloadForAge(values, handle, min_age, max_age, age_slider){
  // var value = values[handle];
  // var date = new Date(parseInt(value))
  // var date_str = moment(date).format('MM/DD/YYYY')
  //
  // if (handle == 0) {
  //   min_age.text(date_str)
  // } else {
  //   max_age.text(date_str)
  // }

  setTimeout(function(){ 
    let url = new URL(window.location.href);

    var values = age_slider.noUiSlider.get()

    values[0] !== '0.00' && url.searchParams.set('published_at_from', values[0])
    values[1] !== '1000000000.00'&& url.searchParams.set('published_at_to', values[1])

    window.location.href = url.href;
  }, 1000);
}

function reloadForEngagements(values, handle, min_eng, max_eng, eng_slider){
  // var value = values[handle];
  //
  // if (handle == 0) {
  //   min_eng.text(formatToHumanNumber(parseInt(value)));
  // } else {
  //   max_eng.text(formatToHumanNumber(parseInt(value)));
  // }
  setTimeout(function(){ 
    let url = new URL(window.location.href);

    var values = eng_slider.noUiSlider.get()
    values[0] !== '0.00' && url.searchParams.set('engagement_from', values[0])

    values[1] !== '1000000000.00'&& url.searchParams.set('engagement_to', values[1])
  
    window.location.href = url.href;
  }, 1000);
}

function updateEngValues(values, handle, min_eng, max_eng, ob_slider) {
  var value = values[handle];

  if (handle == 0) {
    min_eng.text(formatToHumanNumber(parseInt(value)));
  } else {
    max_eng.text(formatToHumanNumber(parseInt(value)));
  }
}


function updateValues(values, handle, min_ob, max_ob, ob_slider) {
  var value = values[handle];
  var date = new Date(parseInt(value))
  var date_str = moment(date).format('MM/DD/YYYY')

  if (handle == 0) {
    min_ob.text(date_str)
  } else {
    max_ob.text(date_str)
  }
}


function reloadForObservedAt(values, handle, min_ob, max_ob, ob_slider){
  // var value = values[handle];
  // var date = new Date(parseInt(value))
  // var date_str = moment(date).format('MM/DD/YYYY')
  //
  // if (handle == 0) {
  //   min_ob.text(date_str)
  // } else {
  //   max_ob.text(date_str)
  // }

  setTimeout(function(){ 
    let url = new URL(window.location.href);

    var values = ob_slider.noUiSlider.get()

    values[0] !== '0.00' && url.searchParams.set('observed_at_from', values[0])
    values[1] !== '1000000000.00'&& url.searchParams.set('observed_at_to', values[1])
  
    window.location.href = url.href;
  }, 1000);
}

function formatToHumanNumber(value) {
  if(value >= 1000000000){
    return (value / 1000000000).toFixed(0) + 'B'
  } else if (value >= 1000000) {
    return (value / 1000000).toFixed(0) + 'M'
  } else if (value >= 100000) {
    return (value / 1000).toFixed(0) + 'K'
  } else if (value >= 10000) {
    return (value / 1000).toFixed(0) + 'K'
  } else if (value >= 1000) {
    return (value / 1000).toFixed(0) + 'K'
  } else {
    return value
  }
}
